export const handleKeySubmit = (key, onClick) => {
  // Enter = 13
  let ENTER_KEY = 13;
  // Space = 32
  let SPACE_KEY = 32
  switch (key) {
    case ENTER_KEY:
      onClick();
      break;
  case SPACE_KEY:
      onClick();
      break;
    default:
      break;
  }
}


// WEBPACK FOOTER //
// ./src/utilities/userUtil.js